import { render } from "./DetailCategoriesComponent.vue?vue&type=template&id=0c400a52&scoped=true"
import script from "./DetailCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./DetailCategoriesComponent.vue?vue&type=script&lang=js"

import "./DetailCategoriesComponent.vue?vue&type=style&index=0&id=0c400a52&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c400a52"]])

export default __exports__